import styled from '@emotion/styled';
import { Button } from '@silvertours/front-shared';

const OptionsWrapper = styled.div<{ asOverlay: boolean }>`
  grid-area: options;
  border-left: ${({ asOverlay, theme }) =>
    asOverlay ? '0' : `1px solid ${theme.colors.neutral.grey80}`};
  margin-left: ${({ asOverlay }) => (asOverlay ? '0' : '1rem')};
  padding-left: ${({ asOverlay }) => (asOverlay ? '0' : '1rem')};
  padding-right: ${({ asOverlay }) => (asOverlay ? '0' : '1rem')};
  width: 320px;
  box-sizing: content-box;
`;

const OptionsSection = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;

  &:not(&:first-of-type) {
    margin-top: 1.5rem;
  }
`;

const StyledLabel = styled.div`
  display: block;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0.625rem;
`;

const StyledButton = styled(Button)`
  margin-top: 1rem;
`;

const CheckboxContainer = styled.div`
  width: 100%;
  display: inline-flex;
  cursor: pointer;
  user-select: none;
  flex-wrap: wrap;
  gap: 0.75rem;

  > label {
    width: 45%;
    align-items: center;
  }
`;

export {
  OptionsSection,
  OptionsWrapper,
  StyledLabel,
  StyledButton,
  CheckboxContainer,
};
